import { render, staticRenderFns } from "./DkLoginInput.vue?vue&type=template&id=635c4b80&"
import script from "./DkLoginInput.vue?vue&type=script&lang=js&"
export * from "./DkLoginInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports